<h1 mat-dialog-title>
    Atenção
    <a class="cursor-pointer decoration-none float-end text-dark" (click)="close()">
        <i class="far fa-times"></i>
    </a>
</h1>
<div mat-dialog-content>
    <p>
        Tem certeza que deseja {{action}} {{message}}?
    </p>
</div>
<div mat-dialog-actions class="d-flex justify-content-between">
    <button mat-stroked-button type="button" (click)="close()" tabindex="-1">
        <i class="far fa-ban me-2"></i>Não
    </button>
    <button mat-flat-button type="submit" color="primary" (click)="confirm()">
        <i class="far fa-check me-2"></i>Sim
    </button>
</div>